import { render, staticRenderFns } from "./AccountsPayableCard.vue?vue&type=template&id=23373afc&"
import script from "./AccountsPayableCard.vue?vue&type=script&lang=js&"
export * from "./AccountsPayableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports